import { trpc } from "../../lib/trpc";
import "./Purchasing.css";

const CUR_SYM: Record<string, string> = { TRY: "₺", USD: "$", EUR: "€", GBP: "£" };

export function fmtMoney(n: number, currency: string): string {
  return `${new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(n)} ${CUR_SYM[currency] ?? currency}`;
}
function fmtDate(d: Date | string): string {
  return new Date(d).toLocaleDateString("tr-TR");
}

/** Bir ürünün geçmiş alış (sipariş) fiyatları + fark (Δ) tablosu. excludePoId ile mevcut PO hariç tutulur. */
export function PriceHistoryTable({ itemId, excludePoId }: { itemId: string; excludePoId?: string }) {
  const q = trpc.purchasing.priceHistory.useQuery({ itemId, excludePoId: excludePoId ?? null }, { staleTime: 10_000 });
  const rows = q.data?.rows ?? [];

  if (q.isLoading) return <div style={{ fontSize: 12, color: "var(--neutral-500)", padding: "6px 2px" }}>Fiyat geçmişi yükleniyor…</div>;
  if (rows.length === 0) return <div style={{ fontSize: 12, color: "var(--neutral-500)", padding: "6px 2px" }}>Bu ürün için geçmiş alış fiyatı kaydı yok.</div>;

  return (
    <table className="dt2" style={{ fontSize: 12.5 }}>
      <thead>
        <tr>
          <th>Sipariş</th>
          <th style={{ width: 96 }}>Tarih</th>
          <th>Tedarikçi</th>
          <th className="num" style={{ width: 120 }}>Birim Fiyat</th>
          <th className="num" style={{ width: 110 }}>Fark (Δ)</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => {
          const cls = r.delta == null ? "po-delta-flat" : r.delta > 0 ? "po-delta-up" : r.delta < 0 ? "po-delta-down" : "po-delta-flat";
          return (
            <tr key={`${r.poCode}-${i}`}>
              <td><span className="cell-id" style={{ fontSize: 11 }}>{r.poCode}</span></td>
              <td className="mono" style={{ fontSize: 11.5 }}>{fmtDate(r.date)}</td>
              <td>{r.supplierName}</td>
              <td className="cell-num">{fmtMoney(r.unitPrice, r.currency)}</td>
              <td className="cell-num">
                {r.delta == null ? <span className="po-delta-flat">—</span> : (
                  <span className={cls}>
                    {r.delta > 0 ? "▲ " : r.delta < 0 ? "▼ " : ""}{fmtMoney(Math.abs(r.delta), r.currency)}
                    {r.deltaPct != null ? ` (${r.delta > 0 ? "+" : "−"}${Math.abs(r.deltaPct).toFixed(1)}%)` : ""}
                  </span>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
